@if (environment.data.brand === 'prixtel') {
    <app-recharge-data-prixtel [line]="line" [procedureCode]="procedureCode"
                               [priceDetails]="priceDetails"></app-recharge-data-prixtel>
}
@if (environment.data.brand === 'coriolis') {
    <app-recharge-data-coriolis [line]="line" [procedureCode]="procedureCode"
                                [customer]="customer"></app-recharge-data-coriolis>
}


